import React from 'react';
import {
  string,
  arrayOf,
  objectOf,
  shape,
  number,
  oneOfType,
} from 'prop-types';
import { Grid } from '@material-ui/core';
import DefaultContainer from '../../DefaultContainer';
import Image from '../../Image';
import styles from './style.module.scss';

const ContainerNoFrame = ({ images, style, imagePadding }) => (
  <DefaultContainer
    justify="center"
    // wrap="nowrap"
    style={style}
    className={styles.container}
  >
    {
      images.map(img => (
        <Grid item xs={12} sm key={img.main || img.fall}>
          <Image
            source={img}
            alt="case phone no frame"
            style={{
              display: 'block',
              margin: 'auto',
              width: '100%',
            }}
            className={[
              styles.image,
              imagePadding && styles.imagePadding,
            ].join(' ')}
          />
        </Grid>
      ))
    }
  </DefaultContainer>
);

ContainerNoFrame.propTypes = {
  images: arrayOf(shape).isRequired,
  style: objectOf(oneOfType([
    string,
    number,
  ])),
};

ContainerNoFrame.defaultProps = {
  style: null,
};

export default ContainerNoFrame;
